import React, {useState, useMemo, useEffect, useContext} from 'react';
import styled from 'styled-components';

import theme, {bp} from 'settings/theme';

import {SearchContext} from 'services/searchService';


type Props = {
  paramType: SearchParamType
};


// Component
const Component: React.FC<Props> = (props) => {

    const search = useContext(SearchContext);

    return (
      <StyledComponent className="searchCheckboxes">
        Range Control
      </StyledComponent>
    );

}

export default Component;




// Styles
const StyledComponent = styled.div`

  display: block;

`



